var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"features__list"},_vm._l((_vm.features),function(feature,index){return _c('FeatureItem',{key:index,class:{ feature__reverse_layout: (index + 1) % 2 === 0 },attrs:{"feature":_vm.parseFeature(feature)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }